/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RegisterDenyType = {
  type: 'Enum',
} as const;
